import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Entry } from 'contentful';
import { BlogpageService } from 'src/app/features/company/blog/blogpage.service';

@Injectable({
  providedIn: 'root',
})
export class ArticleResolver implements Resolve<Entry<any>[]> {
  constructor(private blogPageService: BlogpageService) {}

  resolve(route: ActivatedRouteSnapshot): Promise<Entry<any>[]> {
    return this.blogPageService.getArticleByID(route.paramMap.get('id'));
  }
}
